(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/actions/add-item.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/actions/add-item.js');
"use strict";


const addItem = callback => (item, callbackFn, timeout) => {
  callback(item, callbackFn, timeout);
};
setGlobal('svs.components.selfserviceCart.fns.actions.addItem', addItem);

 })(window);